import { useSetFilter } from '../../filter';
import { FileOrderKey } from '../domain';

export const useSetFileListOrder = () => {
  return useSetFilter(FileOrderKey, 'fileOrderBy', true);
};
